export default __webpack_public_path__ + "static/media/img_sub_fail.7397cbeb.png";